export const RouteType = {
  FILE: "/file",

  //Crud routes
  STORE: "/store",
  DELETE: "/delete",

  //login
  ADMIN: "/admin",
  AUTH: "/auth",
  LOGIN: "/login",

  HOME: "/home",
  DASHBOARD: "/dashboard",
  MENU: "/menu",

  //Blog
  BLOG: "/blog",

  FINANCIAL_PROTECTION: "/financial-protection-guideline",
  FINANCIAL_PROTECTION_GUIDELINE_MESSAGE: "/financial-protection-guidelines-message",

   // Financial Status
   UPDATE_FINANCIAL_STATUS: "/update-financial-status",


  // Events
  EVENT: "/event",
  UPCOMING_EVENTS: "/upcoming-events",
  PAST_EVENTS: "/past-events",

  GET_COUNTRY: "/get-country",
  GET_STATE: "/get-state",
  GET_CITY: "/get-city",
  GET_CURRENCY: "/get-currency",

  COMPANY_LIST: "/company-list",

  //member Search
  MEMBER_SEARCH: "/member-search",

  //upload certificate
  UPLOAD_CERTIFICATE: "/upload-certificate",

  //Grievance Redressal
  GRIEVANCE_REDRESSAL: "/grievance-redressal",
  VIEW_GRIEVANCE_DETAILS: "/view-grievance-details",

  //UPLOAD_CERTIFICATE: '/upload-certificate',
  CERTIFICATE: "/certificate",
  CERTIFICATE_LIST_BY_COMAPANY_ID: "/certificate-list-by-company-id",
  //DELETE_CERTIFICATE: '/delete-certificate',

  //Invoice management
  INVOICE_MANAGEMENT: "/invoice-management",
  UNREAD_COUNT:"/unread-count",
  UNREAD_INVOICE_LIST:'/unread-invoice-list',
  GET_INVOICE: "/get-invoice",
  FILTER_INVOICE: "/filter-invoice",

  //FounderMember
  RECENT_MEMBERS: "/recent-members",

  // News Announcements
  NEWS_ANNOUNCEMENTS: "/newsubmission",
  ANNOUNCEMENT: "/announcement",

  // Member Login
  MEMBER_LOGIN: "/get-loginlog",

  // Announcement Display
  ANNOUNCEMENT_DISPLAY: "/view-announcement",

  // Company Profile
  COMPANY_PROFILE: "/company-profile",
  BRANCH_COMPANY_PROFILE: "/branch-company-profile",
  
  // Company Services
  COMPANY_SERVICES: "/company-services",
  
  // News Letters
  NEWS_LETTERS: "/newsletter",
  RECENT_NEWSLETTERS: "/recent-newsletter",

  // Contact Person List By Company Id
  COMPANY_LIST_BY_ID: "/company-list-by-id",

  COMPANY_SERVICES_LIST_BY_ID: "/company-services-list-by-id",

  INVOICE_MANAGEMENT_STATUS_COUNT: "/invoice-management/status-count",
  
  // Contact Enquiry
  CONTACT_ENQUIRY: "/contact-enquiry",

  // Featured In News Letter
  FEATURED_IN_NEWSLETTER: "/featured-in-newsletter",

  // News Letter Subscribers
  NEWSLETTER_SUBSCRIBERS: "/newsletter-subscribers",

  // Registered Member List
  MEMBER: "/member",
  UPDATE_MEMBERSHIP: "/update-membership",

  // Membership Status
  UPDATE_MEMBER_STATUS: "/update-member-status",
  UPDATE_MEMBER_PASSWORD:"/update-member-password",

  // Get Company List By Country Id
  COMPANY_LIST_BY_COUNTRYID: "/company-list-by-countryid",

  // Get Contact Person List By Company ID
  CONTACTPERSON_LIST_BY_COMPANYID: "/contactPerson-list-by-companyid",

  // Meet Online
  MEMBER_MEET_ONLINE: "/member-meet-online",

  // Chat And Meet
  CHAT_MEET: "/chat-meet",
  CONTACTPERSON_LIST: "/contactperson-list",
  CHAT_MEET_COUNT: "/chat-meet-count",
  MARK_AS_READ: "/mark-as-read",
  MARK_AS_ACTIVE: "/mark-as-active",
  MARK_AS_DEACTIVE: "/mark-as-deactive",

  // Visitor Details
  VISITED_PROFILE: "/visited-profile",
  COUNT: "/count",

  // Get Request Quotes OverView Data
  REQUEST_QUOTE: "/request-quote",
  COUNT_QUOTE_COUNTRY: "/count-quote-country",
  REQUEST_QUOTE_LIST: "/request-quote-list",
  COUNT_UNREAD_QUOTE: "/count-unread-quote",
  UNREAD_QUOTE_LIST:"/unread-quote-list",
  


  BANK:"/bank",

  //Member registration
  MEMBERSHIP_REGISTER: '/membership-register',
  UPDATE_MEMBER: '/update-member',
  ADD_BRANCH: '/add-branch',
  MEMBER_BRANCH_REGISTER: "/membership-branch-register",


  FIXED_COMPANY_SERVICES: '/fixed-company-services',
  GET_BRANCHES_BY_COMPANY_ID: "/get-branches-by-company-id",

  FORGOT_PASSWORD: "/forgot-password",
  ALL_ANNOUNCEMENT: "/allannouncement",
};
